// extracted by mini-css-extract-plugin
export default {"navigate":"Footer_navigate__S-73L","nav":"Footer_nav__EWR3i","link":"Footer_link__3Ie8d","copyright":"Footer_copyright__JQMtz"};